export const findDraggingElement = (draggableId: string): HTMLElement =>
  document.querySelector(`[data-draggableid="${draggableId}"]`);
